import React, {useEffect, useMemo, useState} from "../../__snowpack__/pkg/react.js";
import {Divider, Modal, Select} from "../../__snowpack__/pkg/antd.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {TextQuantitative} from "./TextQuantitative.js";
import {PlusOutlined} from "../../__snowpack__/pkg/@ant-design/icons.js";
import {omit} from "../../__snowpack__/pkg/lodash.js";
const {Option} = Select;
export const SelectInputQuantitative = (props) => {
  const [addedOptions, setAddedOptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState();
  const [unit, setUnit] = useState();
  const curUnit = useMemo(() => {
    return unit || props.unitOptions.find((_) => _)?.value;
  }, [unit, props.unitOptions]);
  const curOption = useMemo(() => {
    return [...props.options, ...addedOptions];
  }, [props.options, addedOptions]);
  useEffect(() => {
    if (visible) {
      setValue(void 0);
      setUnit(void 0);
    }
  }, [visible]);
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Select, {
    showSearch: true,
    optionFilterProp: "title",
    placeholder: props.placeholder,
    dropdownRender: (menu) => /* @__PURE__ */ React.createElement("div", null, menu, /* @__PURE__ */ React.createElement(Divider, {
      style: {margin: "4px 0"}
    }), /* @__PURE__ */ React.createElement("div", {
      style: {padding: "4px 8px", cursor: "pointer"},
      onMouseDown: (e) => e.preventDefault(),
      onClick: () => {
        setVisible(true);
      }
    }, /* @__PURE__ */ React.createElement(PlusOutlined, null), " ", props.addAttributeValueMsg)),
    ...omit(props, "options")
  }, curOption.map((_) => {
    return /* @__PURE__ */ React.createElement(Option, {
      key: _.value,
      value: _.value
    }, _.label);
  })), /* @__PURE__ */ React.createElement(Modal, {
    visible,
    closable: false,
    onOk: () => {
      if (value && unit) {
        const newValue = `${value.trim()}${unit}`;
        if (!curOption.find((_) => _.value === newValue || _.label === newValue)) {
          setAddedOptions([
            ...addedOptions,
            {
              value: newValue,
              label: newValue
            }
          ]);
        }
        props.onChange && props.onChange(newValue);
      }
      setVisible(false);
    },
    onCancel: () => {
      setVisible(false);
    }
  }, /* @__PURE__ */ React.createElement(TextQuantitative, {
    value: {unit: curUnit, value},
    options: props.unitOptions,
    onChange: (values) => {
      setUnit(values?.unit);
      setValue(values?.value);
    },
    placeholder: props.pleaseEnterMsg,
    optionWidth: props.unitOptionWidth
  })));
};
const Wrapper = styled.div`
  .ant-select-selection {
    width: 100%;
  }
`;
